export default __webpack_public_path__ + "media/images/banners/months/bnr_8-d0d1df65204c4835af36531ebab92efb.jpg";